// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1LeJ2","gfeWrapper":"CalendarEvent_gfeWrapper__1HD7_"};